import React from 'react';
import ImageIcon from '../../assets/images/button-icons/image-icon.png';
import { get, getNestedElement } from '../../utils/utils';

const ViewProfilePhoto = ({ spaceProfilePhotos, fieldKey, setAssetImagesState, fieldSettings }) => {
  const isFieldPhotosEnabled = (key, fieldSettings) => fieldSettings ? get(fieldSettings, `${key}.photosEnabled`, false) : true;

  const fieldPhotos = React.useMemo(() => ((spaceProfilePhotos && getNestedElement(spaceProfilePhotos, `${fieldKey}.files`)) || []).map(_ => _.url), [spaceProfilePhotos, fieldKey]);

  if (!isFieldPhotosEnabled(fieldKey, fieldSettings) || !fieldPhotos?.length) return null;

  return (
    <div style={{ marginLeft: '5px', marginRight: '10px' }} onClick={() => setAssetImagesState({ isOpen: true, images: fieldPhotos, index: 0 })}>
      <img src={ImageIcon} alt="Images" />
    </div>
  )
}

export default ViewProfilePhoto;
